import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
import { getUserId } from "../services/authorize";

export default function StudentDocument() {

  const { setLoading } = useLoading();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  // จัดการ State สำหรับปีการศึกษาและข้อมูลที่โหลดได้
  const [yearList, setYearList] = useState([])
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null
  })

  const [selectedYear, setSelectedYear] = useState("")
  const [data, setData] = useState([]);

  // ดึงรายการปีการศึกษา
  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API}/getStudyYear`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
      .then((res) => {
        const list = res.data;
        setYearList(list || []);
       // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
      let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId));
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "");
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [setLoading])

  const [roomId, setRoomId] = useState(0)  
  useEffect(() => {
    if (!yearId) return;
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getRoomIdByAdvisorId/${getUserId()}/${yearId}`,
    {
      headers: {
            authorization: `Bearer ${getToken()}`
        }
    })
        .then(response => {
            setRoomId(response.data)
            // setIsLoading(false)
            // console.log(response.data)
        })
        .catch(err => {
            console.log(err.response.data.message)
            Swal.fire({
                title: err.response.data.title || err.response.statusText,
                text: err.response.data.message || err.message,
                icon: "error"
            })
        }).finally(() => {
          setLoading(false);
        })
    }, [setLoading, yearId]);

  useEffect(() => {
    if (!roomId) return;
    setLoading(true);
        
    axiosInstance.get(`${process.env.REACT_APP_API}/listStudentsInClass/${roomId}`,
    {
      headers: {
          authorization: `Bearer ${getToken()}`
      }
    })
      .then(response => {
        setData(response.data)
        // setIsLoading(false)
        // console.log(response.data)
      })
      .catch(err => {
        console.log(err.response.data.message)
        Swal.fire({
          title: err.response.data.title || err.response.statusText,
          text: err.response.data.message || err.message,
          icon: "error"
        })
      }).finally(() => {
        setLoading(false);
      })

  }, [setLoading, roomId]);

  // Handle การเปลี่ยนปีการศึกษาจาก Dropdown
  const handleSelectYear = (id) => {
    const selected = yearList.find(y => y.year_id === id);
    if (selected) {
      setYearId(id);
      setSelectedYear(`ปีการศึกษา ${selected.year_year}`);
      localStorage.setItem('yearId', id); // <-- เก็บลง LocalStorage
    }
  }

  return (
    <React.Fragment>
      <style>{`.pp-link { background-color: lightblue; padding: 2px 4px; border-radius: 3px; } .pp-link:hover { background-color: lightgray; }`}</style>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item">
                <Link to="#">ข้อมูลประจำชั้น</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                แบบ ปพ.ต่างๆ
              </li>
            </ol>
            <h4 className="main-title mb-0">แบบ ปพ.ต่างๆ ในห้องที่ปรึกษา/ครูประจำชั้น</h4>
          </div>
      
          {/* Dropdown เลือกปีการศึกษา */}
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>
          
              <Dropdown.Menu>
                {yearList.map((item) => (
                <Dropdown.Item
                  key={item.year_id}
                  onClick={() => handleSelectYear(item.year_id)}
                >
                  {`ปีการศึกษา ${item.year_year}`}
                </Dropdown.Item>
              ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              {/* <Card.Header>
                <Card.Title as="h6">รายชื่อนักเรียนชั้น ม. {c_class + '/' + r_no}</Card.Title>
                <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav>
              </Card.Header> */}
              <Card.Body className="p-3">
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center" style={{ width:"50px" }}>เลขที่</th>
                      <th scope="col" className="text-center" style={{ width: "100px" }}>เลขประจำตัว</th>
                      <th scope="col">ชื่อ-สกุล</th>
                      <th scope="col" className="text-center" style={{ width: "120px" }}>สถานะ</th>
                      <th scope="col" className="text-center" style={{ width: "120px" }}>ปริ้น ปพ.</th>
                      <th scope="col" className="text-center" style={{ width: "150px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                  {data && data.length > 0 ? (
                  data.map((data, index) => (
                      <tr key={data.st_id} className={data.st_status === '0' ? 'table-danger' : ''}>
                        <th scope="row" className="text-center">{++index}</th>
                        <td className="text-center">{data.st_idnumber}</td>
                        <td>{data.st_name}</td>
                        <td className={data.st_status === '0' 
                            ? 'text-center text-danger' 
                            : data.st_status === '1'
                            ? 'text-center text-primary'
                            : 'text-center text-success'
                        }>
                          {data.status_text}
                        </td>
                        <td className="text-center">
                          <Link to={`/advisor/student-pp-6/${data.st_id}`} className="pp-link">ปพ. 6</Link>
                          <Link className="ms-1 pp-link" to={`/advisor/student-pp-8/${data.st_id}`}>ปพ. 8</Link>
                        </td>
                        <td className="text-center"><Link to={`/advisor/student-info/${data.st_id}`}><i className="ri-contacts-book-2-line"> อัพเดทข้อมูล</i></Link></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  )
}